var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { class: _vm.classes.root }, [
    _c(
      "button",
      {
        class: _vm.classes.buttonPrevious,
        style: {
          visibility: _vm.index <= 1 ? "hidden" : "visible",
        },
        attrs: { "aria-hidden": "true" },
        on: {
          click: function ($event) {
            _vm.index-- && _vm.updatePosition(_vm.index)
          },
        },
      },
      [
        _vm._t("button-previous", function () {
          return [
            _c("span", { staticClass: "material-icons" }, [
              _vm._v("arrow_back"),
            ]),
          ]
        }),
      ],
      2
    ),
    _vm._v(" "),
    _c(
      "div",
      { class: _vm.classes.track },
      _vm._l(_vm.items, function (item) {
        return _c(
          "div",
          {
            key: item.key,
            ref: "contentSliderItems",
            refInFor: true,
            class: _vm.classes.item,
          },
          [_vm._t("content-slider-item", null, { data: item.data })],
          2
        )
      }),
      0
    ),
    _vm._v(" "),
    _c(
      "button",
      {
        class: _vm.classes.buttonNext,
        style: {
          visibility:
            _vm.index === _vm.items.length - 2 || _vm.items.length <= 1
              ? "hidden"
              : "visible",
        },
        attrs: { "aria-hidden": "true" },
        on: {
          click: function ($event) {
            _vm.index++ && _vm.updatePosition(_vm.index)
          },
        },
      },
      [
        _vm._t("button-next", function () {
          return [
            _c("span", { staticClass: "material-icons" }, [
              _vm._v("arrow_forward"),
            ]),
          ]
        }),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./scripts/components/ContentSlider.vue